<template>
  <transition name="fade">
    <div v-if="loading" class="loading"><span>Loading...</span></div>
  </transition>
<!--    <div class="debugConsole">-->
<!--      <div v-for="item in debugConsole" class="item">{{item}}</div>-->
<!--    </div>-->

  <teleport to="body">
    <div class="start-menu" v-if="!userInteracted">
      <div class="top">
        <div class="title">
          <img class="responsive" src="@/assets/images/main/title.svg" alt="title">
        </div>
        <div class="sound">
          <img class="responsive" src="@/assets/images/main/sound.svg" alt="sound">
        </div>
      </div>

      <div class="drozdov">
        <img class="responsive" src="@/assets/images/main/drozdov.png" alt="drozdov">
      </div>
      <div class="box">
        <img class="responsive" src="@/assets/images/main/box.png" alt="box">
      </div>

      <div class="bottom">
        <div class="text">
          <span>Наведите</span> камеру телефона <span>на обитателей</span> этой лесной упаковки
          <span>и узнайте</span> забавные факты об удивительном мире леса!
        </div>
        <div class="button" @click="startAR">
          <div class="circle-center">
            <div class="circle-inner">
              начать
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <transition name="fade">
      <div class="info-block" v-if="infoIsUp">
        <div class="logo">
          <img src="@/assets/images/logo.svg" alt="logo">
        </div>
        <div class="text">{{infoText}}</div>
        <div class="postscript">
          Узнайте больше про удивительный мир леса на
          <a href="https://dobro.svetocopy.com/" target="_blank">dobro.svetocopy.com</a>
        </div>
      </div>
    </transition>
  </teleport>

  <div class="toggle-volume" @click="toggleVolume">
    <img v-if="playersMuted" class="responsive" src="@/assets/images/unmute.png" alt="unmute">
    <img v-else class="responsive" src="@/assets/images/mute.png" alt="mute">
  </div>

  <transition name="fade">
<!--    <div class="playing-overlay" v-if="animationIsPlaying"></div>-->
    <div
      class="playing-overlay"
      :class="{'opacity-1': animationIsPlaying}"
    >
      <transition name="fade">
        <div
          class="elk-animation"
          :class="{'opacity-1': elkAnimated}"
        >
          <img id="elkImg" ref="elkImg" src="/ar/sprites/elk_map.png" alt="elk">
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { onMounted, ref } from 'vue';
import * as THREE from 'three/build/three.module.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { gsap } from 'gsap';
import { AR, loadingManager } from '@/assets/utils/ar.js';
import logoImgSrc from '@/assets/images/logo.svg';
import elkMapSrc from '@/assets/images/elk_map.png';

export default {
  name: 'Pattern',
  setup() {
    {
      // preload logoImg
      const logoImg = new Image();
      logoImg.src = logoImgSrc;
      // // preload logoImg
      // const elkImage = new Image();
      // elkImage.src = elkMapSrc;
    }

    const debugConsole = ref([]);
    const loading = ref(false);
    const userInteracted = ref(false);
    const animationIsPlaying = ref(false);
    const infoText = ref('Мы выявляем и сохраняем на своих участках места обитания более 10'
    + ' видов редких животных, среди которых есть и белка-летяга, а также около'
    + ' 60 уникальных видов растений.');
    const infoIsUp = ref(false);
    const elkAnimated = ref(false);

    let scene;
    let camera;
    let renderer;
    let clock;
    let deltaTime;
    let totalTime;
    let arToolkitSource;
    let arToolkitContext;

    const markersTemplate = [
      {
        name: 'squirrel',
        audioSrc: '/ar/audio/squirrel.mp3',
        patternName: 'pattern-1',
        infoText: 'Мы выявляем и сохраняем на своих участках места обитания более 10'
          + ' видов редких животных, среди которых есть и белка-летяга, а также около'
          + ' 60 уникальных видов растений.',
        onAnimationStart() {
          this.showInfoTimer = setTimeout(() => {
            infoText.value = this.infoText;
            infoIsUp.value = true;
          }, 5000);
        },
        onAnimationStop() {
          infoIsUp.value = false;
          clearTimeout(this.showInfoTimer);
        },
        // debug(info) {
        //   debugConsole.value.push(renderer.info.memory.textures);
        // },
        sprites: [
          {
            name: 'squirrel',
            src: '/ar/sprites/squirrel_map.png',
            layer: 0,
            widthRatio: 1,
            heightRatio: 1,
            tilesHoriz: 8,
            tilesVert: 9,
            numTiles: 65,
            duration: 5,
            scale: 9.2,
            x: 0.5,
            z: -4,
            repeat: true,
          },
        ],
      },
      {
        name: 'otter',
        audioSrc: '/ar/audio/otter.mp3',
        patternName: 'pattern-2',
        infoText: 'Мы сохраняем места обитания выдр и других животных и не проводим там работ по лесозаготовкам.',
        onAnimationStart() {
          this.showInfoTimer = setTimeout(() => {
            infoText.value = this.infoText;
            infoIsUp.value = true;
          }, 5000);
        },
        onAnimationStop() {
          infoIsUp.value = false;
          clearTimeout(this.showInfoTimer);
        },
        sprites: [
          {
            name: 'otter',
            src: '/ar/sprites/otter_map.png',
            layer: 0,
            widthRatio: 1,
            heightRatio: 1,
            tilesHoriz: 8,
            tilesVert: 9,
            numTiles: 65,
            duration: 5,
            scale: 9.2,
            x: 2.3,
            z: 0,
            repeat: true,
          },
        ],
      },
      {
        name: 'elk',
        audioSrc: '/ar/audio/elk.mp3',
        patternName: 'pattern-3',
        infoText: 'Мы сохраняем леса с высокой природоохранной ценностью и поддерживаем'
          + ' разнообразие лесных экосистем.',
        onAnimationStart() {
          elkAnimated.value = true;
          this.showInfoTimer = setTimeout(() => {
            infoText.value = this.infoText;
            infoIsUp.value = true;
          }, 5000);
        },
        onAnimationStop() {
          elkAnimated.value = false;
          infoIsUp.value = false;
          clearTimeout(this.showInfoTimer);
        },
        debug(info) {
          debugConsole.value.push(info);
        },
        htmlId: '#elkImg',
        sprites: [
          {
            name: 'elk',
            src: '/ar/sprites/elk_map.png',
            layer: 0,
            widthRatio: 1,
            heightRatio: 1,
            tilesHoriz: 8,
            tilesVert: 9,
            numTiles: 65,
            duration: 5,
            scale: 9.2,
            x: 2.3,
            z: 0.5,
            repeat: true,
          },
        ],
      },
      {
        name: 'woodpecker',
        audioSrc: '/ar/audio/woodpecker.mp3',
        patternName: 'pattern-4',
        infoText: 'Мы ежегодно устанавливаем на своих участках кормушки, скворечники и'
          + ' гнездовья для пернатых обитателей леса.',
        onAnimationStart() {
          this.showInfoTimer = setTimeout(() => {
            infoText.value = this.infoText;
            infoIsUp.value = true;
          }, 5000);
        },
        onAnimationStop() {
          infoIsUp.value = false;
          clearTimeout(this.showInfoTimer);
        },
        sprites: [
          {
            name: 'woodpecker',
            src: '/ar/sprites/woodpecker_map.png',
            layer: 0,
            widthRatio: 1,
            heightRatio: 1,
            tilesHoriz: 8,
            tilesVert: 9,
            numTiles: 65,
            duration: 5,
            scale: 9.2,
            x: 2.5,
            z: 1,
            repeat: true,
          },
        ],
      },
      {
        name: 'tree1',
        audioSrc: '/ar/audio/tree1.mp3',
        patternName: 'pattern-5',
        infoText: 'Мы проводим выборочные рубки ухода – убираем часть ослабленных деревьев,'
          + ' которые мешают развиваться хвойным лесам.',
        onAnimationStart() {
          this.showInfoTimer = setTimeout(() => {
            infoText.value = this.infoText;
            infoIsUp.value = true;
          }, 5000);
        },
        onAnimationStop() {
          infoIsUp.value = false;
          clearTimeout(this.showInfoTimer);
        },
        sprites: [
          {
            name: 'tree1',
            src: '/ar/sprites/tree1_map.png',
            layer: 0,
            widthRatio: 1,
            heightRatio: 1,
            tilesHoriz: 8,
            tilesVert: 9,
            numTiles: 65,
            duration: 5,
            scale: 9.2,
            x: 2,
            z: 0.5,
            repeat: true,
          },
        ],
      },
      {
        name: 'tree2',
        audioSrc: '/ar/audio/tree2.mp3',
        patternName: 'pattern-6',
        infoText: 'Мы высаживаем 3 новых сеянца взамен одного вырубленного дерева или'
          + ' около 1 миллиона сеянцев в год!',
        onAnimationStart() {
          this.showInfoTimer = setTimeout(() => {
            infoText.value = this.infoText;
            infoIsUp.value = true;
          }, 5000);
        },
        onAnimationStop() {
          infoIsUp.value = false;
          clearTimeout(this.showInfoTimer);
        },
        sprites: [
          {
            name: 'tree2',
            src: '/ar/sprites/tree2_map.png',
            layer: 0,
            widthRatio: 1,
            heightRatio: 1,
            tilesHoriz: 8,
            tilesVert: 9,
            numTiles: 65,
            duration: 5,
            scale: 9.2,
            x: -2.2,
            z: 1,
            repeat: true,
          },
        ],
      },
    ];
    const ar = new AR(
      markersTemplate,
      {
        onPlay() {
          if (ar.animationIsPlaying) animationIsPlaying.value = true;
        },
        onStop() {
          if (!ar.animationIsPlaying) animationIsPlaying.value = false;
        },
        onLoading() {
          loading.value = true;
        },
        onLoad() {
          loading.value = false;
        },
      },
    );

    const setupThreeJS = () => {
      scene = new THREE.Scene();

      const ambientLight = new THREE.AmbientLight(0xcccccc, 1.0);
      scene.add(ambientLight);

      camera = new THREE.Camera();
      scene.add(camera);
      renderer = new THREE.WebGLRenderer({
        antialias: false,
        alpha: true,
      });
      renderer.setClearColor(new THREE.Color('lightgrey'), 0);
      renderer.setSize(window.innerWidth, window.innerHeight);
      // renderer.setSize(640, 480);
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.domElement.style.position = 'absolute';
      renderer.domElement.style.top = '0px';
      renderer.domElement.style.left = '0px';
      document.body.appendChild(renderer.domElement);

      clock = new THREE.Clock();
      deltaTime = 0;
      totalTime = 0;
    };

    const setupARToolkit = () => {
      // setup arToolkitSource
      arToolkitSource = new THREEx.ArToolkitSource({
        sourceType: 'webcam',
        sourceWidth: 1280,
        sourceHeight: 960,
      });

      function onResize() {
        arToolkitSource.onResize();
        arToolkitSource.copySizeTo(renderer.domElement);
        if (arToolkitContext.arController !== null) {
          arToolkitSource.copySizeTo(arToolkitContext.arController.canvas);
        }
      }

      arToolkitSource.init(() => {
        setTimeout(() => {
          onResize();
        }, 1000);
      });

      // handle resize event
      window.addEventListener('resize', () => {
        onResize();
      });

      // setup arToolkitContext
      // create atToolkitContext
      arToolkitContext = new THREEx.ArToolkitContext({
        cameraParametersUrl: '/ar/data/camera_para.dat',
        maxDetectionRate: 80,
        detectionMode: 'mono',
      });

      // copy projection matrix to camera when initialization complete
      arToolkitContext.init(() => {
        camera.projectionMatrix.copy(arToolkitContext.getProjectionMatrix());
      });
    };

    const init = () => {
      setupThreeJS();
      setupARToolkit();
      ar.setupMarkerRoots(scene, arToolkitContext);

      loadingManager.onLoad = function onLoad() {
        console.log('Content Loaded!');
        // loading.value = false;
      };
    };

    const updateARToolkit = () => {
      // update artoolkit on every frame
      if (arToolkitSource.ready !== false) {
        arToolkitContext.update(arToolkitSource.domElement);
      }
    };

    const render = () => {
      renderer.render(scene, camera);
    };

    const animate = (time) => {
      requestAnimationFrame(animate);
      deltaTime = clock.getDelta();
      totalTime += deltaTime;

      try {
        ar.update(deltaTime, debugConsole);

        updateARToolkit();
        render();
      } catch (e) {
        console.log(e);
        alert(e.message);
      }
    };

    init();
    animate();

    const startAR = () => {
      userInteracted.value = true;
      ar.initPlayersOnClick();
    };

    const playersMuted = ref(false);
    const toggleVolume = () => {
      playersMuted.value = !playersMuted.value;
      ar.toggleVolume();
    };

    const elkImg = ref(null);
    // // eslint-disable-next-line max-len
    // const initSpriteAnimation = (el, frames, col, duration) => {
    //   const width = gsap.getProperty(el.parentNode, 'width');
    //   const height = gsap.getProperty(el.parentNode, 'height');
    //   const tl = gsap.timeline({ repeat: -1 });
    //
    //   for (let i = 0; i < frames; i++) {
    //     tl.set(el, {
    //       x: (i % col) * -width,
    //       y: (Math.floor(frames / col) - Math.floor(i / col)) * -height,
    //     }, i / (frames - 1) * duration);
    //   }
    //   return tl;
    // };

    onMounted(() => {
      // initSpriteAnimation(elkImg.value, 65, 8, 5, true);
      console.log(elkImg);
      markersTemplate[2].htmlId = elkImg.value;
    });

    return {
      debugConsole,
      loading,
      userInteracted,
      animationIsPlaying,
      infoText,
      infoIsUp,
      startAR,
      playersMuted,
      toggleVolume,
      elkImg,
      // initSpriteAnimation,
      elkAnimated,
    };
  },
};
</script>
<style lang="scss" scoped>
.responsive {
  display: block;
  width: 100%;
  height: auto;
}
.debugConsole {
  z-index: 999999;

  position: absolute;
  max-width: 100vw;
  background-color: #fff;
  text-align: center;
  top: 0;
  left: 0;
  font-size: 20px;
  justify-content: center;
  padding: 10px;
  .item {
    text-align: center;
  }
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  padding: 2px 10px;
  //display: inline;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 10;
  font-size: 30px;
  text-align: center;
}

.start-menu {
  z-index: 100;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  @media (max-height: 568px) {
    padding: 14px;
  }
  .top {
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    z-index: 4;
    .title {
      position: relative;
      img {
        max-width: 260px;
        @media (max-height: 700px) {
          max-width: 220px;
        }
        @media (max-height: 568px) {
          max-width: 180px;
        }
        @media (min-width: 768px) {
          min-width: 400px;
        }
        @media (min-width: 1024px) {
          min-width: 600px;
        }
      }
    }
    .sound {
      margin-top: 18px;
      padding-right: 20px;
      align-self: flex-end;
      @media (max-height: 700px) {
        margin-top: 10px;
      }
      @media (min-width: 768px) {
        margin-top: 24px;
      }
      @media (min-width: 1024px) {
        margin-top: 42px;
      }

      img {
        max-width: 110px;

        @media (max-width: 320px) {
          max-width: 80px;
        }
        @media (min-width: 420px) {
          max-width: 110px;
        }
        @media (min-width: 768px) {
          max-width: 120px;
        }
        @media (min-width: 1024px) {
          min-width: 200px;
        }
        @media (max-height: 568px) {
          max-width: 60px;
        }
      }
    }
  }
  .drozdov {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(calc(-50% - 50px));
    z-index: 3;
    img {
      max-width: 260px;
      @media (max-width: 320px) {
        max-width: 200px;
      }
      @media (min-width: 420px) {
        min-width: 300px;
      }
      @media (min-width: 768px) {
        min-width: 400px;
      }
      @media (min-width: 1024px) {
        min-width: 580px;
      }
      @media (max-height: 568px) {
        max-width: 180px;
      }
    }
  }
  .box {
    position: absolute;
    right: 0;
    bottom: 170px;
    z-index: 3;
    img {
      @media (max-height: 700px) {
        max-width: 210px;
      }
      @media (max-width: 320px) {
        max-width: 180px;
      }
      @media (min-width: 768px) {
        min-width: 420px
      }
      @media (min-width: 1024px) {
        min-width: 520px;
      }
      @media (max-height: 568px) {
        max-width: 160px;
      }
    }
    @media (max-width: 320px) {
      bottom: 160px;
    }
    @media (min-width: 768px) {
      bottom: 190px;
    }
    @media (min-width: 1024px) {
      bottom: 240px;
    }
    @media (max-height: 568px) {
      bottom: 110px;
    }
  }
  .bottom {
    align-self: center;
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 90%;
    .text {
      font-family: 'Montserrat', sans-serif;
      font-weight: normal;
      font-size: 14px;
      line-height: 16.5px;
      color: #54853C;
      @media (max-width: 320px) {
        font-size: 12px;
      }
      @media (min-width: 768px) {
        font-size: 24px;
        line-height: 24px;
      }
      @media (min-width: 1024px) {
        font-size: 30px;
        line-height: 30px;
      }
      @media (max-height: 568px) {
        font-size: 8px;
      }
      span {
        white-space: nowrap;
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
        text-transform: uppercase;
        @media (max-width: 320px) {
          font-size: 16px;
          line-height: 24px;
        }
        @media (min-width: 768px) {
          font-size: 28px;
          line-height: 34px;
        }
        @media (min-width: 1024px) {
          font-size: 36px;
          line-height: 40px;
        }
        @media (max-height: 568px) {
          font-size: 12px;
          line-height: 12px;
        }
      }
    }
    .button {
      margin-top: 21px;
      border-radius: 30px;
      background-color: #AAB226;
      padding: 5px;
      @media (max-width: 320px) {
        margin-top: 12px;
      }
      @media (min-width: 768px) {
        padding: 7px;
      }
      @media (min-width: 1024px) {
        padding: 10px;
      }
      @media (max-height: 568px) {
        margin-top: 6px;
        padding: 3px;
      }
      .circle-center {
        border-radius: 30px;
        background-color: #4E7732;
        padding: 5px;
        @media (min-width: 768px) {
          padding: 7px;
        }
        @media (min-width: 1024px) {
          padding: 10px;
        }
        @media (max-height: 568px) {
          padding: 3px;
        }
        .circle-inner {
          font-family: 'Montserrat', sans-serif;
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          background-color: #324519;
          padding: 10px 30px;
          border-radius: 20px;
          @media (min-width: 768px) {
            font-size: 24px;
          }
          @media (min-width: 1024px) {
            padding: 16px 36px;
            font-size: 36px;
          }
          @media (max-height: 568px) {
            padding: 6px 18px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.info-block {
  z-index: 1;
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: #538414;
  color: #ffffff;
  font-size: 24px;
  line-height: 27px;
  font-family: 'Helios', sans-serif;
  font-weight: normal;
  padding: 30px 35px;
  @media (max-width: 500px) {
    padding: 20px 25px;
    font-size: 18px;
  }
  @media (max-width: 420px) {
    padding: 10px 15px;
    font-size: 12px;
    line-height: 16px;
  }
  .logo {
    img {
      width: 100%;
      max-width: 180px;
      height: auto;
      display: block;
      @media (max-width: 500px) {
        max-width: 130px;
      }
      @media (max-width: 420px) {
        max-width: 70px;
      }
    }
  }
  .text {
    margin-top: 20px;
    @media (max-width: 500px) {
      margin-top: 10px;
    }
    @media (max-width: 420px) {
      margin-top: 5px;
    }
  }
  .postscript {
    margin-top: 10px;
    font-weight: bold;
    @media (max-width: 420px) {
      margin-top: 5px;
    }
    //@media (max-height: 568px) {
    //  margin-top: 5px;
    //}
    a,
    a:link,
    a:visited,
    a:active {
      color: #ffffff;
      transition: color 0.4s;
    }
    a:hover {
      color: rgba(255, 255, 255, 0.56);
    }
  }
}

.toggle-volume {
  z-index: 10;
  background-color: #fff;
  border-radius: 50%;
  padding: 4px;
  position: absolute;
  right: 14px;
  top: 20px;
  img {
    max-width: 26px;
  }
}

.playing-overlay {
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.4s ease-out;

  $elkWidth: 512px;
  $elkHeight: 512px;
  .elk-animation {
    position: relative;
    bottom: 100px;
    transition: opacity 0.4s ease-out;
    opacity: 0;

    $scale: 0.7;
    $cols: 8;
    $rows: 9;
    width: $elkWidth * $scale;
    height: $elkHeight * $scale;
    overflow: hidden;
    img {
      height: $elkHeight * $rows * $scale;
      width: $elkWidth * $cols * $scale;
    }
  }
}
.opacity-1 {
  opacity: 1 !important;
}
</style>
